import {
    addBreadcrumb,
    clearAllBreadcrumbs,
    clearAllBreadcrumbsUpTill,
} from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(addBreadcrumb, actionMessage => {
    const { breadcrumb } = actionMessage;

    getStore().breadcrumbs.push(breadcrumb);
});

mutator(clearAllBreadcrumbs, () => {
    const store = getStore();
    store.breadcrumbs = [];
});

mutator(clearAllBreadcrumbsUpTill, actionMessage => {
    const { folderId } = actionMessage;
    const store = getStore();

    if (!folderId) {
        // As the provider breadcrumb is not stored
        // in store so we clear all the breadcrumbs
        store.breadcrumbs = [];
    } else {
        const [folderBreadcrumb] = store.breadcrumbs.filter(b => b.id === folderId);

        if (folderBreadcrumb) {
            // If the folder breadcrumbs is found then remove all the breadcrumbs
            // upto the selected breadcrumb
            const indexOfBreadcrumb = store.breadcrumbs.indexOf(folderBreadcrumb);
            store.breadcrumbs.splice(indexOfBreadcrumb);
        }
    }
});
